<template>
  <div>
    <!-- 置顶弹框 -->
    <el-dialog :title="title" width="600px" :visible.sync="isVisible" @close="closeModal">

      <div class="label">
        {{ $t('设置置顶到期时间') }}:
      </div>

      <div class="df aic mt-26">
        <el-radio v-model="isdata" :label="true" @change="handleIsData(20)">{{ $t('置顶至') }}</el-radio>
        <div class="f1">
          <el-date-picker v-model="ruleForm.deadline" :disabled="!isdata" type="date" style="width: 100%;"
            :placeholder="$t('请选择日期')" :picker-options="pickerOptions"></el-date-picker>
        </div>
        <span class="ml-16">{{ $t('结束') }}</span>
      </div>

      <div class="mt-16">
        <el-radio v-model="isdata" :label="false" @change="handleIsData(10)">{{ $t('长期') }}</el-radio>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="btn1" @click="closeModal()">{{ $t('取消') }}</el-button>
        <el-button type="primary" class="btn2" @click="submitPost">{{ $t('确定') }}</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          // 获取今天的日期（不包含时间）
          const today = new Date();
          today.setHours(0, 0, 0, 0); // 将时间设置为0点，确保比较时不考虑时间部分
          // 比较传入的日期是否小于今天
          return time.getTime() < today.getTime();
        }
      },
      isVisible: false,

      isdata: false,

      ruleForm: {
        id: 0,
        top_up_type: 10,
        deadline: '',
      }

    }
  },
  // 接收参数
  props: {
    title: {
      type: String,
      default: '审核'
    },
    id: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    let Language = localStorage.getItem('currentLanguage');  //获取本地语言
    if (Language && Language != 'zh') {
      locale.use(lang)
    }

  },
  methods: {
    handleIsData(val) {
      this.ruleForm.top_up_type = val;
      if (val == 10) {
        this.ruleForm.deadline = ''; // 如果选择长期，清空日期选择器的值
      }
    },
    openModal() {
      this.isVisible = true;
    },

    closeModal() {
      this.ruleForm = {
        id: 0,
        top_up_type: 10,
        dadline: '',
      }
      this.isVisible = false;
      this.isdata = false;
    },

    submitPost() {
      this.ruleForm.id = this.id;
      this.$emit('poster-submitted', this.ruleForm);
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep() {
  .el-form-item__label {
    color: #040a16;
    font-size: 14px;
  }

  .el-radio__input.is-checked+.el-radio__label {
    // color: #040a16;
    font-size: 14px;
  }

  .el-form-item__content {
    padding-left: 16px;
  }


  .el-dialog__header {
    padding: 28px 32px 0px;
  }

  .el-dialog {
    max-height: 82vh;
    border-radius: 12px;
  }

  .el-dialog__body {
    margin-top: 20px;
    width: calc(100% - 20px);
    padding: 0px 12px 2px 32px;
    max-height: calc(82vh - 180px);
    overflow: hidden;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 6px;
      height: 4px;
      background: transparent;
      border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background: #CF4325;
      border-radius: 8px;
    }
  }

  .el-dialog__footer {
    padding: 26px 36px 26px;
  }
}


.dialog-footer {

  .btn1,
  .btn2 {
    min-width: 76px;
    height: 36px;
    border-radius: 30px;
    padding: 0 16px;
    font-size: 14px;
  }

  .btn1 {
    background-color: #ffffff;
    border: 1px solid #ededed;

    &:hover {
      border: 1px solid #d9462f;
    }
  }

  .btn2 {
    background: linear-gradient(to right, #eb6f54, #d9462f);
    border: none;

    &:hover {
      background: linear-gradient(to right, #d9462f, #d9462f);
    }
  }
}
</style>